import { Footer } from "./Footer";
import { Navbar } from "./Navbar";
import { useParams } from "react-router";
import { useState, useEffect } from "react";
import Noty from "noty";
import { axiosInstance } from "../../constants/axiosInstance";
import { baseURL } from "../../constants/baseURL";
import { Star } from 'lucide-react';



export const OrderDetail = () => {
  const { orderid: orderId } = useParams();
  const [order, setOrder] = useState({});
  const [reviewableProducts, setReviewableProducts] = useState({});
  const [activeReviewProduct, setActiveReviewProduct] = useState(null);
  const [reviewData, setReviewData] = useState({
    rating: 0,
    comment: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [reviewError, setReviewError] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
  console.log("Token in localStorage:", token);
  
  getOrderDetail();
}, [orderId]);

useEffect(() => {
  console.log('Full order object:', order);
  console.log('Order status:', order?.status, 'Type:', typeof order?.status);
  
  if (order?.details && order.status === 5) {
    console.log('Checking review eligibility for products');
    order.details.forEach(detail => {
      console.log('Product ID:', detail.productId?._id);
      checkReviewEligibility(detail.productId?._id);
    });
  }
}, [order]);

  const getOrderDetail = async () => {
    try {
      const res = await axiosInstance.get('/api/v1/order/getorderbyorderid', {
        params: { orderId }
      });
      setOrder(res.data.data[0]);
    } catch (err) {
      new Noty({
        type: "error",
        timeout: 2000,
        text: "Something Went Wrong"
      }).show();
    }
  };


  // Inside OrderDetail.js
  const checkReviewEligibility = async (productId) => {
    try {
        const token = localStorage.getItem('token');
        console.log('Token from localStorage:', token); // Debug log
        
        if (!token) {
            console.log('No token found');
            setReviewableProducts(prev => ({
                ...prev,
                [productId]: false
            }));
            return;
        }

        // No need to set headers manually as axios interceptor will handle it
        const response = await axiosInstance.get(
            `/api/v1/reviews/check-review-eligibility/${orderId}/${productId}`
        );
        
        console.log('Eligibility response:', response.data);
        
        setReviewableProducts(prev => ({
            ...prev,
            [productId]: response.data.canReview
        }));
    } catch (err) {
        console.error('Review eligibility check error:', err.response?.data || err);
        setReviewableProducts(prev => ({
            ...prev,
            [productId]: false
        }));
    }
};


  const handleSubmitReview = async (productId) => {
    setIsSubmitting(true);
    setReviewError('');

    try {
      const response = await axiosInstance.post('/api/v1/reviews/create', {
        rating: reviewData.rating,
        comment: reviewData.comment,
        productId,
        orderId
      });

      if (response.data.success) {
        new Noty({
          type: "success",
          timeout: 2000,
          text: "Review submitted successfully"
        }).show();
        
        // Update reviewable products state
        setReviewableProducts(prev => ({
          ...prev,
          [productId]: false
        }));
        setActiveReviewProduct(null);
        setReviewData({ rating: 0, comment: '' });
        
        // Refresh order details to update UI
        await getOrderDetail();
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'Failed to submit review';
      setReviewError(errorMessage);
      new Noty({
        type: "error",
        timeout: 2000,
        text: errorMessage
      }).show();
    } finally {
      setIsSubmitting(false);
    }
  };
  useEffect(() => {
    console.log('Reviewable products updated:', reviewableProducts);
  }, [reviewableProducts]);


  const renderReviewSection = (product) => {
    if (order.status !== 5) return null;
  
    return (
      <div className="mt-6">
        {activeReviewProduct === product._id ? (
          <div className="bg-gradient-to-br from-white to-gray-50 p-6 rounded-xl shadow-lg border border-gray-200">
            {/* Header */}
            <div className="flex justify-between items-center mb-6">
              <div>
                <h4 className="text-xl font-bold text-gray-900">Share Your Experience</h4>
                <p className="text-sm text-gray-500 mt-1">Your review helps others make better choices</p>
              </div>
              <button 
                onClick={() => setActiveReviewProduct(null)}
                className="text-gray-400 hover:text-gray-600 p-2 hover:bg-gray-100 rounded-full transition-all duration-200"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
  
            {/* Error Message */}
            {reviewError && (
              <div className="mb-6 p-4 bg-red-50 border-l-4 border-red-500 text-red-700 text-sm">
                <div className="flex items-center">
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                  </svg>
                  {reviewError}
                </div>
              </div>
            )}
  
            {/* Rating Section */}
            <div className="mb-8">
              <label className="block text-lg font-semibold text-gray-800 mb-3">Rate this product</label>
              <div className="flex gap-3">
                {[1, 2, 3, 4, 5].map((value) => (
                  <button
                    key={value}
                    type="button"
                    className="focus:outline-none transform transition-all duration-200 hover:-translate-y-1"
                    onClick={() => setReviewData(prev => ({
                      ...prev,
                      rating: value
                    }))}
                  >
                    <Star
                      className={`w-10 h-10 ${
                        value <= reviewData.rating
                          ? 'fill-yellow-400 text-yellow-400'
                          : 'text-gray-300 hover:text-yellow-300'
                      } transition-colors duration-200`}
                    />
                  </button>
                ))}
              </div>
              <p className="text-sm text-gray-500 mt-2">
                {reviewData.rating === 0 ? 'Select your rating' : 
                 reviewData.rating === 5 ? 'Excellent!' :
                 reviewData.rating === 4 ? 'Very Good!' :
                 reviewData.rating === 3 ? 'Good' :
                 reviewData.rating === 2 ? 'Fair' : 'Poor'}
              </p>
            </div>
  
            {/* Review Text Section */}
            <div className="mb-6">
              <label className="block text-lg font-semibold text-gray-800 mb-3">Write your review</label>
              <textarea
                value={reviewData.comment}
                onChange={(e) => setReviewData(prev => ({
                  ...prev,
                  comment: e.target.value
                }))}
                className="w-full p-4 border-2 rounded-xl focus:ring-2 focus:ring-blue-100 focus:border-blue-300 
                         transition-all duration-200 min-h-[150px] text-gray-700 resize-none bg-white"
                placeholder="What did you like or dislike? What did you use this product for?"
                required
                minLength="10"
                maxLength="500"
              />
              <div className="flex justify-between items-center mt-2">
                <p className="text-sm text-gray-500">Minimum 10 characters</p>
                <p className="text-sm text-gray-500">{reviewData.comment.length}/500</p>
              </div>
            </div>
  
            {/* Submit Button */}
            <button
              onClick={() => handleSubmitReview(product._id)}
              disabled={isSubmitting || !reviewData.rating || !reviewData.comment}
              className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl py-4 px-6
                       hover:from-blue-700 hover:to-blue-800 disabled:from-gray-400 disabled:to-gray-500
                       disabled:cursor-not-allowed transition-all duration-300 transform hover:-translate-y-0.5
                       font-semibold text-lg shadow-md hover:shadow-lg disabled:hover:transform-none"
            >
              {isSubmitting ? (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white mr-3"></div>
                  Submitting Review...
                </div>
              ) : (
                'Post Review'
              )}
            </button>
          </div>
        ) : (
          <button 
            onClick={() => setActiveReviewProduct(product._id)}
            className="flex items-center gap-2 text-white bg-gradient-to-r from-blue-600 to-blue-700 
                     hover:from-blue-700 hover:to-blue-800 px-6 py-3 rounded-xl transition-all duration-300 
                     transform hover:-translate-y-0.5 font-semibold shadow-md hover:shadow-lg"
          >
            <Star className="w-5 h-5" />
            Write Product Review
          </button>
        )}
      </div>
    );
  };
  return (
    <>
      <div className="py-14 px-4 md:px-6 2xl:px-20 2xl:container 2xl:mx-auto">
        <div className="flex justify-start item-start space-y-2 flex-col">
          <h1 className="text-3xl  lg:text-4xl font-semibold leading-7 lg:leading-9 text-gray-800">Order #{order?.orderid}</h1>
          <p className="text-base font-medium leading-6 text-gray-600">{order?.date} at {order?.time}</p>
        </div>
        <div className="mt-10 flex flex-col xl:flex-row jusitfy-center items-stretch w-full xl:space-x-8 space-y-4 md:space-y-6 xl:space-y-0">
          <div className="flex flex-col justify-start items-start w-full space-y-4 md:space-y-6 xl:space-y-8">
            <div className="flex flex-col justify-start items-start bg-gray-50 px-4 py-4 md:py-6 md:p-6 xl:p-8 w-full">
              <p className="text-lg md:text-xl font-semibold leading-6 xl:leading-5 text-gray-800">Customer’s Cart</p>
              {order?.details?.map((orderDetail, index) => (
  <div key={index} className="mt-4 md:mt-6 flex flex-col md:flex-row justify-start items-start md:items-center md:space-x-6 xl:space-x-8 w-full">
    <div className="pb-4 md:pb-8 w-full md:w-40">
      <img className="w-full hidden md:block rounded-full h-32" src={`${baseURL + orderDetail?.productId?.productPhoto}`} alt="dress" />
      <img className="w-full md:hidden h-32 rounded-full" src={`${baseURL + orderDetail?.productId?.productPhoto}`} alt="dress" />
    </div>
    <div className="border-b border-gray-200 md:flex-row flex-col flex justify-between items-start w-full pb-8 space-y-4 md:space-y-0">
      <div className="w-full flex flex-col justify-start items-start space-y-8">
        <h3 className="text-xl xl:text-2xl font-semibold leading-6 text-gray-800">{orderDetail?.productId?.name}</h3>
        <div className="flex justify-start items-start flex-col space-y-2">
          <p className="text-sm leading-none text-gray-800"><span className=" text-gray-300">Brand: </span> {orderDetail?.productId?.brand}</p>
          <p className="text-sm leading-none text-gray-800"><span className=" text-gray-300">Category: </span> {orderDetail?.productId?.category}</p>
          <p className="text-sm leading-none text-gray-800"><span className=" text-gray-300">Sub-Category: </span> {orderDetail?.productId?.subCategory}</p>
          <p className="text-sm leading-none text-gray-800"><span className=" text-gray-300">Type: </span> {orderDetail?.productId?.type}</p>
        </div>
      </div>
      <div className="flex justify-between space-x-8 items-start w-full">
        <p className="text-base xl:text-lg leading-6">${orderDetail?.productId?.price}</p>
        <p className="text-base xl:text-lg leading-6 text-gray-800">{orderDetail?.quantity}</p>
        <p className="text-base xl:text-lg font-semibold leading-6 text-gray-800">${orderDetail?.productTotal}</p>
      </div>
      {/* Add review section here */}
      {order.status === 5 && orderDetail.productId && renderReviewSection(orderDetail.productId)}
      </div>
  </div>
))}
            </div>
            <div className="flex justify-center flex-col md:flex-row items-stretch w-full space-y-4 md:space-y-0 md:space-x-6 xl:space-x-8">
              <div className="flex flex-col px-4 py-6 md:p-6 xl:p-8 w-full bg-gray-50 space-y-6">
                <h3 className="text-xl font-semibold leading-5 text-gray-800">Summary</h3>
                <div className="flex justify-center items-center w-full space-y-4 flex-col border-gray-200 border-b pb-4">
                  <div className="flex justify-between w-full">
                    <p className="text-base leading-4 text-gray-800">Subtotal</p>
                    <p className="text-base leading-4 text-gray-600">${order?.subTotal}</p>
                  </div>
                  <div className="flex justify-between items-center w-full">
                    <p className="text-base leading-4 text-gray-800">Delivery Charges</p>
                    <p className="text-base leading-4 text-gray-600">${order?.deliveryFee}</p>
                  </div>
                </div>
                <div className="flex justify-between items-center w-full">
                  <p className="text-base font-semibold leading-4 text-gray-800">Total</p>
                  <p className="text-base font-semibold leading-4 text-gray-600">${order?.totalPrice}</p>
                

                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 w-full xl:w-96 flex justify-between items-center md:items-start px-4 py-6 md:p-6 xl:p-8 flex-col">
            <h3 className="text-xl font-semibold leading-5 text-gray-800">Customer</h3>
            <div className="flex flex-col md:flex-row xl:flex-col justify-start items-stretch h-full w-full md:space-x-6 lg:space-x-8 xl:space-x-0">
              <div className="flex flex-col justify-start items-start flex-shrink-0">
                <div className="flex justify-center w-full md:justify-start items-center space-x-4 py-8 border-b border-gray-200">
                  <img className="rounded-full" src={`${order?.userId?.profilePhoto !== '' ? baseURL + order?.userId?.profilePhoto : 'https://i.ibb.co/5TSg7f6/Rectangle-18.png'}`} alt="avatar" />
                  <div className="flex justify-start items-start flex-col space-y-2">
                    <p className="text-base font-semibold leading-4 text-left text-gray-800">{order?.userId?.fullName}</p>
                    <p className="text-sm leading-5 text-gray-600">{order?.userId?.deliveryZipCode}</p>
                  </div>
                </div>
                <div className="flex justify-center text-gray-800 md:justify-start items-center space-x-4 py-4 border-b border-gray-200 w-full">
                  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 5H5C3.89543 5 3 5.89543 3 7V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V7C21 5.89543 20.1046 5 19 5Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M3 7L12 13L21 7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  <p className="cursor-pointer text-sm leading-5 ">{order?.userId?.email}</p>
                </div>
              </div>
              <div className="flex justify-between xl:h-full items-stretch w-full flex-col mt-6 md:mt-0">
                <div className="flex justify-center md:justify-start xl:flex-col flex-col md:space-x-6 lg:space-x-8 xl:space-x-0 space-y-4 xl:space-y-12 md:space-y-0 md:flex-row items-center md:items-start">
                  <div className="flex justify-center md:justify-start items-center md:items-start flex-col space-y-4 xl:mt-8">
                    <p className="text-base font-semibold leading-4 text-center md:text-left text-gray-800">Shipping Address</p>
                    <p className="w-48 lg:w-full xl:w-48 text-center md:text-left text-sm leading-5 text-gray-600">{order?.address}</p>
                  </div>
                  <div className="flex justify-center md:justify-start items-center md:items-start flex-col space-y-4">
                    <p className="text-base font-semibold leading-4 text-center md:text-left text-gray-800">Billing Address</p>
                    <p className="w-48 lg:w-full xl:w-48 text-center md:text-left text-sm leading-5 text-gray-600">{order?.userId?.formattedAddress}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </>

  )
}
